<div class="navbar py-2 top-bar fixed-top bg-dark d-flex align-items-center justify-content-between px-4">
  <button pButton type="button" label="voltar" icon="pi pi-arrow-left" class="p-button-text p-button-white"
    (click)="goBack()"></button>

  <section class="login-section">
    <button pButton type="button" routerLink="/" label="Fórum" icon="pi pi-comments"
      class="p-button-text p-button-warning" iconPos="right"></button>
  </section>
</div>
